import { render, staticRenderFns } from "./ForceGraph.vue?vue&type=template&id=06770688&"
import script from "./ForceGraph.vue?vue&type=script&lang=js&"
export * from "./ForceGraph.vue?vue&type=script&lang=js&"
import style0 from "./ForceGraph.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports